import { ARBITRUM, AVALANCHE, AVALANCHE_FUJI, CUSTOM_DEV_NETWORK } from "config/chains";
import invert from "lodash/invert";

export const NETWORK_QUERY_PARAM = "network";
export const VERSION_QUERY_PARAM = "v";

export const NETWORK_SLUGS_ID_MAP = {
  arbitrum: ARBITRUM,
  avalanche: AVALANCHE,
  avalanche_fuji: AVALANCHE_FUJI,
  devnet: CUSTOM_DEV_NETWORK,
};

export const NETWORK_ID_SLUGS_MAP = invert(NETWORK_SLUGS_ID_MAP);
